import * as React from 'react'

const EyeClose = (props: any) => {
  return (
    <svg {...props} width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M13.9412 1.00461C13.338 2.19923 12.3822 3.21125 11.1764 3.93261L12.6567 5.41294C12.8703 5.6265 12.8703 5.97275 12.6567 6.18633C12.4431 6.39989 12.0969 6.39989 11.8833 6.18633L10.1467 4.44965C9.32817 4.78841 8.44962 4.99218 7.54686 5.05083V7.52954C7.54686 7.83158 7.30203 8.07642 6.99999 8.07642C6.69795 8.07642 6.45311 7.83158 6.45311 7.52954V5.05086C5.55036 4.9922 4.6718 4.78844 3.8533 4.44968L2.11667 6.18636C1.90309 6.39994 1.5568 6.39994 1.34325 6.18636C1.12972 5.97281 1.12972 5.62655 1.34328 5.41297L2.82359 3.93263C1.61778 3.21128 0.661952 2.19926 0.0588038 1.00464C-0.0773134 0.735002 0.0309132 0.406111 0.300523 0.269967C0.57005 0.133822 0.899077 0.242022 1.03517 0.511659C2.04957 2.52079 4.31018 3.97485 7.00002 3.97485C9.69187 3.97485 11.9513 2.51904 12.9648 0.511631C13.1012 0.241557 13.4303 0.134014 13.6995 0.26994C13.9691 0.406085 14.0773 0.735002 13.9412 1.00461Z'
        fill='#979797'
      />
    </svg>
  )
}
export default EyeClose



// WEBPACK FOOTER //
// ./src/components/icons/main-menu/EyeClose.tsx